import React, { useState } from 'react';
import ImageExpand from '../ImageExpand';
import Asset from '../Asset';
import styles from './ModuleNavattic.module.scss';
import Modal from 'react-bootstrap/Modal';
import cx from 'clsx';


const ModuleNavattic = (props) => {
  const { image, imageExpand, _id, navattic } = props
  const [expandImage, setExpandImage] = useState(false)
  const iframeSrc = navattic && navattic.match(/src="([^"]+)"/);
  const url = iframeSrc ? iframeSrc[1] : null;
  const handleExpandImage = (value, e) => {
    setExpandImage(false)
  }
  React.useEffect(() => {
    if (expandImage) {
      const navatticConetnt = document.querySelector('.modal-content')
      if (navatticConetnt) {
        navatticConetnt.style.height = "90%";
      }
    }
  }, [expandImage])
  return (
    <div data-testid="ModuleNavattic" className={styles.hideOnSmallScreen}>
      {image ? (
        <div className={imageExpand ? styles.navatticFrame : ""} onClick={() => {
          setExpandImage(true)
        }}>
          <Asset {...image} />
        </div>
      ) : null}
      {imageExpand &&
        <Modal
          show={expandImage}
          onHide={() => setExpandImage(false)}
          backdrop
          scrollable
          centered
          size="xl"
          animation={false}
          className={styles.modalDialog}>
          <Modal.Body>
            <>
              <iframe
                src={url}
                title="Navattic Demo"
                width="100%"
                height="100%"
                frameBorder="0"
                className={styles.navatiVideoPlayer}
              />
              <a href="#" className={cx(styles.imageExpand, styles.close)} onClick={(e) => handleExpandImage(false, e)}>
                <Asset url="/images/assets/icon-close-x.svg" title="Close image" isInlineSvg />
              </a>
            </>
          </Modal.Body>
        </Modal>
      }
    </div>
  )
};

export default ModuleNavattic;